// extracted by mini-css-extract-plugin
export default {"deleteButton":"delete-icon-button_deleteButton__VW6SI"};